<template>
    <button class="button icon-button" @click="$emit('click')">
        <icon class="button-icon" :name="icon"/>
    </button>
</template>

<script>
  import Icon       from '../Layout/Icon';
  import BaseButton from './BaseButton';

  export default {
    name:       'IconButton',
    components: { Icon },
    extends:    BaseButton,

    props: {
      icon: {
        type:     String,
        required: true,
      },
    },

    data () {
      return {};
    },

    computed: {},

    methods: {},
  };
</script>

<style scoped>
    .icon-button {
        background: none;
        padding:    0;
        color:      var(--color-gray-medium);
    }

    .icon-button:hover,
    .icon-button:focus {
        color: var(--color-primary);
    }

    .icon-button .button-icon {
        padding-top: 2px;
    }
</style>
